import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import Portal from '../Portal';
import * as Styled from './styles';

interface IProps {
    dataRef: string,
    text: string,
    icon: IconProp,
    place?: 'bottom' | 'left' | 'right' | 'top',
    showIcon?: boolean,
    width?: number,
    effect?: 'solid'| 'float',
    offset?: object,
}

const CustomTooltip: FC<IProps> = ({ dataRef, text, place, icon, showIcon, effect, offset, width }) => (
    <Portal>
        <Styled.ReactTooltipWithoutArrow data-test-id="custom-tooltip" id={dataRef} place={place} effect={effect} offset={offset}>
            <Styled.TooltipDiv width={width}>
                {showIcon && <Styled.Icon icon={icon} />}
                <Styled.TooltipText data-test-id="custom-tooltip-text">{text}</Styled.TooltipText>
            </Styled.TooltipDiv>
        </Styled.ReactTooltipWithoutArrow>
    </Portal>
);

CustomTooltip.defaultProps = {
    place: 'bottom',
    icon: 'lock-alt',
    showIcon: true,
    width: 130,
    effect: 'solid',
    offset: {},
};

CustomTooltip.propTypes = {
    dataRef: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    place: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
    icon: PropTypes.any,
    showIcon: PropTypes.bool,
    effect: PropTypes.oneOf(['solid', 'float']),
    width: PropTypes.number,
    offset: PropTypes.object,
};

export default CustomTooltip;
